import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { SortableList } from "components/common";
import MessageFieldEditModeListItem from "./MessageFieldEditModeListItem";
import useFormattedFields from "./hooks/useFormattedFields";
const Container = styled.div(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    display: flex;
    flex-direction: column;
    padding: ${theme.spacings.xs} 0;
  `
);
const ItemContainer = styled.div(
  ({ theme }) => css`
    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.table.row.divider};
    }
    padding: ${theme.spacings.xs} ${theme.spacings.sm};
  `
);
const MessageFieldsEditModeFavoritesList = ({
  fields,
  onFavoriteToggle,
  reorderFavoriteFields
}) => {
  const { t } = useTranslation("common");
  const customContentRender = useCallback(
    ({ item: { field, value, type } }) => /* @__PURE__ */ React.createElement(
      MessageFieldEditModeListItem,
      {
        key: field,
        fieldName: field,
        fieldType: type,
        value,
        isFavorite: true,
        onFavoriteToggle
      }
    ),
    [onFavoriteToggle]
  );
  if (!fields.length) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h3", null, t("message.favorite_fields")), /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    SortableList,
    {
      items: fields,
      onMoveItem: reorderFavoriteFields,
      displayOverlayInPortal: true,
      alignItemContent: "center",
      customContentRender
    }
  )));
};
const MessageFieldsEditModeRestList = ({ fields, onFavoriteToggle }) => {
  const { t } = useTranslation("common");
  if (!fields.length) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h3", null, t("message.remaining_fields")), /* @__PURE__ */ React.createElement(Container, null, fields.map(({ field, type, value }) => /* @__PURE__ */ React.createElement(ItemContainer, { key: field }, /* @__PURE__ */ React.createElement(
    MessageFieldEditModeListItem,
    {
      fieldName: field,
      fieldType: type,
      value,
      isFavorite: false,
      onFavoriteToggle
    }
  )))));
};
const MessageFieldsEditModeLists = ({ reorderFavoriteFields, onFavoriteToggle, editingFavoriteFields }) => {
  const { formattedFavorites, formattedRest } = useFormattedFields(editingFavoriteFields);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    MessageFieldsEditModeFavoritesList,
    {
      reorderFavoriteFields,
      onFavoriteToggle,
      fields: formattedFavorites
    }
  ), /* @__PURE__ */ React.createElement(MessageFieldsEditModeRestList, { onFavoriteToggle, fields: formattedRest }));
};
export default MessageFieldsEditModeLists;
